var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3738 67.8425C57.8765 67.8425 67.9936 52.5104 67.9936 39.2227C67.9936 38.7846 67.9936 38.3465 67.9728 37.9293C69.9336 36.5109 71.6441 34.7378 73 32.7143C71.206 33.507 69.2661 34.0494 67.2218 34.2997C69.3078 33.0481 70.8931 31.0873 71.6441 28.7301C69.7041 29.8774 67.5556 30.7118 65.261 31.1707C63.4253 29.2099 60.8178 28 57.9183 28C52.3695 28 47.8638 32.5057 47.8638 38.0545C47.8638 38.8472 47.9472 39.619 48.1349 40.3491C39.7701 39.9319 32.3648 35.9268 27.4002 29.8357C26.5449 31.3167 26.0443 33.0481 26.0443 34.8838C26.0443 38.3674 27.8174 41.4547 30.5292 43.2486C28.8812 43.2069 27.3376 42.748 25.9817 41.997C25.9817 42.0387 25.9817 42.0805 25.9817 42.1222C25.9817 47.0034 29.4444 51.0502 34.0545 51.9889C33.2201 52.2184 32.3231 52.3436 31.4053 52.3436C30.7586 52.3436 30.1328 52.281 29.507 52.1558C30.7795 56.1609 34.4926 59.0605 38.894 59.1439C35.4521 61.8348 31.1132 63.441 26.3989 63.441C25.5854 63.441 24.7927 63.3993 24 63.295C28.4014 66.1737 33.6999 67.8425 39.3738 67.8425Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.fbf0adbc2254a3e58c8f36cce2a91595.svg";
export { ForwardRef as ReactComponent };